<template>
  <section class="itinerario-poster" ref="sectionRef">
    <h2 class="poster-title">Itinerario</h2>
    <p class="poster-subtitle" ref="subtitleRef">
      <br>  Agradecemos llegar puntual para que no te pierdas ningún detalle del evento.
    </p>

    <div
      v-for="(evento, index) in eventos"
      :key="evento.nombre"
      class="poster-item"
      :ref="el => itemRefs[index] = el"
    >
      <img :src="evento.icono" class="poster-icon" alt="Icono evento" />
      <p class="poster-text">
        <span class="evento-nombre">{{ evento.nombre }}</span>
        <span class="evento-hora">{{ evento.hora }}</span>
        <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
      </p>
       <br>   <br>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Ceremonia (Oración)',
        hora: '6:00 PM',
        nota: 'Se realizará en el mismo lugar del evento\nIllusion Reception Hall',
        icono: require('@/assets/og.png')
      },
      {
        nombre: 'Recepción',
        hora: '6:30 PM',
        icono: require('@/assets/co.png')
      },
        {
        nombre: 'Presentación',
        hora: '7:30 PM',
        icono: require('@/assets/valls.png')
      },
         {
        nombre: 'Cena',
        hora: '8:00 PM',
        icono: require('@/assets/cen.png')
      },
      {
        nombre: 'Baile',
        hora: '9:00 PM - en adelante',
        nota: '¡A disfrutar la fiesta!',
        icono: require('@/assets/fest.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)
    const subtitleRef = ref(null)

    onMounted(() => {
      // Animación del subtítulo (consecutiva al inicio de la sección)
      if (subtitleRef.value) {
        gsap.set(subtitleRef.value, { opacity: 0, y: 20 })
        
        const subObserver = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return
            gsap.fromTo(
              subtitleRef.value,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.1, ease: 'power2.out' }
            )
            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        subObserver.observe(subtitleRef.value)
      }

      // Animaciones de los ítems del itinerario
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef, subtitleRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  background-image:
    linear-gradient(to bottom, rgba(255,255,255,0.83), rgba(255,255,255,0.68)),
    url('../assets/brillos.avif');
  background-size: cover;
  background-position: center;
  text-align: center;
  position: relative;
  margin-top: 45px;
}

/* ==================== ONDAS MÚLTIPLES FLUIDAS (SVG) ==================== */
.itinerario-poster::before,
.itinerario-poster::after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  background-repeat: repeat-x;
  background-size: 100px 30px;
  z-index: 10;
  pointer-events: none;
}

/* Onda Superior Múltiple */
.itinerario-poster::before {
  top: -29px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 30' preserveAspectRatio='none'%3E%3Cpath d='M0,30 C25,0 75,0 100,30 Z' fill='%23DCE1E5'/%3E%3C/svg%3E");
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #252424;
  margin-bottom: 12px;
}

.poster-subtitle {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  color: #212020;
  line-height: 1.5;
  max-width: 550px;
  margin: 0 auto 50px auto;
  padding: 0 25px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
  padding: 0 20px;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

.evento-hora {
  display: block;
  font-size: 23px !important;
  font-style: italic;
  margin-top: 4px;
}

.evento-nota {
  display: block;
  font-size: 17px !important;
  margin-top: 6px;
  color: #323131;
  font-style: italic;
  white-space: pre-line; /* Permite interpretar los saltos de línea \n */
}
</style>